<section class="plans-section">
  <div class="container px-4 lg:px-0 overflow-hidden">
    <!-- desktop-version -->
    <div class="plans-content lg:block ">
      <div class="flex justify-between items-end">
        <header class="mb-8">
          <h2 class="title pt-2">Plans & Pricing</h2>
          <p class="subtitle">We offer multiple residential and business plans, or we can customize your service up to 10 Gbps. Browse all of our available plans using the arrows below.</p>
        </header>
        <div class="lg:flex space-x-5 justify-end items-center hidden">
          <button type="button" role="button" (click)="goToPrev()"
            class="bg-transparent h-[48px] w-[48px] rounded-full flex justify-center items-center border-[1px] border-[#585C67] hover:bg-[#0284C7] hover:border-[#0284C7]">
            <img src="/images/pricing/arrowLeft.svg" alt="" />
          </button>
          <button type="button" role="button" (click)="goToNext()"
            class="bg-[#0284C7] h-[48px] w-[48px] rounded-full flex justify-center items-center border-[1px] border-[#0284C7]">
            <img src="/images/pricing/arrowRight.svg" alt="" />
          </button>
        </div>
      </div>
      <div class="flex items-center pt-8 flex-wrap lg:gap-0 gap-7 ">
        <div class="w-full lg:w-4/12">
          <img src="/images/pricing/1.png" alt="pricing" />
        </div>
        <div class="lg:w-8/12 lg:ps-10 w-full">
          <div class="plans-carousel w-full">
            <owl-carousel-o [options]="customOptions" #owlCarousel>
              <ng-container *ngFor="let plan of pricingPlans">
                <ng-template carouselSlide>
                  <div [ngClass]="{ highlighted: plan.isHighlighted }" class="plan-card mx-auto"
                    style="min-height: 550px">
                    <h3 class="plan-title">{{ plan.title }}</h3>
                    <div class="plan-price mt-4">
                      {{ plan.price | currency: 'USD':'symbol':'1.0-0' }}
                      <span class="plan-frequency">{{ plan.frequency }}</span>
                    </div>
                    <p class="plan-description mt-2">
                      {{ plan.description }}
                    </p>
                    <div class="w-[75%] bg-[#FFFFFF1F] h-[1px] my-2"></div>
                    <ul class="features mt-4 space-y-2">
                      <li *ngFor="let feature of plan.features" class="flex items-center gap-2">
                        <div class="w-[17px] h-[17px] rounded-full flex items-center justify-center bg-white">
                          <img src="/images/pricing/check.svg" alt="check" />
                        </div>
                        <span>{{ feature }}</span>
                      </li>
                    </ul>

                    <button pButton type="button" label="{{ plan.buttonText }}" class="w-full mt-6"
                      style="position: absolute; bottom: 25px; width: 75%; margin-left:13px;" [ngClass]="
                        plan.isHighlighted
                          ? 'p-button-primary'
                          : 'p-button-outlined'
                      " (click)="handleBookNow(plan.id)"></button>
                  </div>
                </ng-template>
              </ng-container>
            </owl-carousel-o>
          </div>
        </div>
      </div>
      <div class="flex lg:hidden space-x-5 justify-center items-center pt-8">
        <button type="button" role="button" (click)="goToPrev()"
          class="bg-transparent h-[48px] w-[48px] rounded-full flex justify-center items-center border-[1px] border-[#585C67] hover:bg-[#0284C7] hover:border-[#0284C7]">
          <img src="/images/pricing/arrowLeft.svg" alt="" />
        </button>
        <button type="button" role="button" (click)="goToNext()"
          class="bg-[#0284C7] h-[48px] w-[48px] rounded-full flex justify-center items-center border-[1px] border-[#0284C7]">
          <img src="/images/pricing/arrowRight.svg" alt="" />
        </button>
      </div>
    </div>
  </div>
</section>
